import type { IBrandConfig } from './types';

const IDG_BRAND_CONFIG: IBrandConfig = {
  privacyPolicy: {
    kind: 'external',
    url: 'https://www.pango.co/legal/privacy-policy',
  },
  termsOfService: {
    kind: 'external',
    url: 'https://member.identityguard.com/terms-of-service/',
  },
  websiteTermsOfUse: { kind: 'none' },
  refundPolicy: { kind: 'none' },
  /* The idg-subbrand brands are the only ones Angular gives an Identity Theft
     Protection document to. */
  idTheftProtection: {
    kind: 'cms',
    path: 'policy/tou/idg-subbrand-theft-protection.md',
  },
  /* ITAC / credit-union partners get the idg-subbrand documents rather than
     the external URLs above. */
  offerGroupLegalOverride: {
    groupCodes: [
      'itac',
      'cuna',
      'itacbatlantic',
      'itacrbc',
      'itaccuna',
      'itacsandia',
      'itacsynovus',
    ],
    privacyPolicy: { kind: 'cms', path: 'policy/tou/idg-subbrand-privacy.md' },
    termsOfService: { kind: 'cms', path: 'policy/tou/idg-subbrand-terms.md' },
  },
  licensor: 'intersections',
  vaultProject: 'identityguard_watson',
  adaChat: true,
  defaultBillingCategoryKey: 'identityguard_fi',
  copyRightEntity: 'Intersections LLC dba Pango',
  hasCustomerServiceSupport: true,
  carouselBanners: true,
  security: true,
  plan: true,
  finishSetup: false,
  secureUpload: true,
  accountDetails: true,
  dwEmailVerification: {
    adaChat: true,
    signInButton: true,
    supportAt: null,
    availability:
      'Representatives are available Monday – Friday, 8AM-11PM ET and Saturday, 9AM-6PM ET.',
  },
  supportPage: {
    pageTitle: {
      active: true,
      title: 'More ways to reach us',
    },
    faq: {
      active: true,
    },
    pages: [],
    call: {
      availability: (
        <>
          Monday – Friday, 8AM-11PM ET <br /> Saturday, 9AM-6PM ET
        </>
      ),
    },
    mail: {
      active: true,
      address: 'PO Box 52330 Boston, MA 02205',
      customerSupport: false,
    },
    email: {
      active: true,
      customerSupport: true,
    },
  },
  faqOverrides: {
    answers: {
      'supportFaqs.victimIdentityTheft': `<p>If you believe you are a victim of identity theft, contact us immediately. A victim recovery specialist will provide a range of expert, personalized advice, and support to help you.</p>
      <p>If you’d like to learn more about our resolution services or if you’d like to manage your own recovery process, please visit <a href='https://go.identityguard.com/ResolutionHub.html' target='_blank' rel='noopener noreferrer'>https://go.identityguard.com/ResolutionHub.html</a>.</p>`,
    },
  },
};

export default IDG_BRAND_CONFIG;
